import PageContainer from '../components/containers/PageContainer';
import CustomTable from '../components/ui/CustomTable';
import { alpha, Box, Button, Stack, TableCell, TableRow, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import api from '../config/axios';
import { formatDate } from '../utilities/misc';
import dayjs from 'dayjs';
import DateFilter from '../components/common/DateFilter';
import { toast } from 'react-toastify';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { useSearchParams } from 'react-router-dom';
import Field from '../components/ui/Field';
import { Search } from '@mui/icons-material';

const filters = [
    ['All', 'All'],
    ['Order', 'Order created'],
    ['CSV Order', 'CSV Order created'],
    ['Amazon Order', 'Amazon Order created'],
    ['Deposit', 'Deposit'],
    ['Refund', 'Refund Accepted'],
    ['Premium', 'Premium'],
    ['Enterprise', 'Enterprise'],
];

const FilterTabs = ({ filter, setFilter }) => {
    const theme = useTheme();
    return (
        <Stack direction="row" spacing={1}>
            {filters.map((f, i) => (
                <Box
                    onClick={() => setFilter(f[1])}
                    sx={{
                        cursor: 'pointer',
                        px: 1,
                        borderRadius: 0.8,
                        border: f[1] === filter && `solid 1px ${theme.palette.primary.main}`,
                        bgcolor: f[1] === filter && alpha(theme.palette.primary.main, 0.2),
                        fontWeight: 500,
                        whiteSpace: 'nowrap',
                    }}>
                    {f[0]}
                </Box>
            ))}
        </Stack>
    );
};

const Transactions = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [transactions, setTransactions] = useState([]);
    const [laoding, setLaoding] = useState(true);
    const [totalPages, setTotalPages] = useState(0);

    const [filter, setFilter] = useState(searchParams.get('type') || 'All');
    const [sort, setSort] = useState(searchParams.get('sort') || 'asc');
    const [page, setPage] = useState(parseInt(searchParams.get('page') || '1', 10));
    const [limit, setLimit] = useState(parseInt(searchParams.get('limit') || '10', 10));
    const [search, setSearch] = useState(searchParams.get('search') || '');
    const [dateRange, setDateRange] = useState({
        startDate: searchParams.get('from') ? dayjs(searchParams.get('from')).toDate() : null,
        endDate: searchParams.get('to') ? dayjs(searchParams.get('to')).toDate() : null,
        key: 'selection',
    });

    const updateUrl = () => {
        const params = new URLSearchParams();

        if (search) params.set('search', search);
        if (filter !== 'All') params.set('type', filter);
        if (sort) params.set('sort', sort);
        if (page > 1) params.set('page', page.toString());
        if (limit !== 10) params.set('limit', limit.toString());
        if (dateRange.startDate) params.set('from', dayjs(dateRange.startDate).format('YYYY-MM-DD'));
        if (dateRange.endDate) params.set('to', dayjs(dateRange.endDate).format('YYYY-MM-DD'));

        setSearchParams(params);
    };

    const readTransactions = async (resetDate = false) => {
        setLaoding(true);
        try {
            const params = new URLSearchParams();
            params.append('page', page.toString());
            params.append('limit', limit.toString());
            params.append('sort', sort);
            params.append('type', filter);

            if (search) params.append('search', search);
            if (dateRange.startDate) params.append('from', dayjs(dateRange.startDate).format('YYYY-MM-DD'));
            if (dateRange.endDate) params.append('to', dayjs(dateRange.endDate).format('YYYY-MM-DD'));

            const link = `/admin/logs?${params.toString()}`;
            const res = await api.get(link);
            setTransactions(res.data.logs);
            setTotalPages(res.data.totalPages);
        } catch (error) {
            console.error(error);
        } finally {
            setLaoding(false);
        }
    };
    useEffect(() => {
        updateUrl();
    }, [filter, sort, page, limit, dateRange]);

    useEffect(() => {
        readTransactions();
    }, [searchParams]);

    const searchlogs = async () => {
        const params = new URLSearchParams();

        if (search) params.set('search', search);
        if (filter !== 'All') params.set('type', filter);
        if (sort) params.set('sort', sort);
        if (page > 1) params.set('page', page.toString());
        if (limit !== 10) params.set('limit', limit.toString());
        if (dateRange.startDate) params.set('from', dayjs(dateRange.startDate).format('YYYY-MM-DD'));
        if (dateRange.endDate) params.set('to', dayjs(dateRange.endDate).format('YYYY-MM-DD'));

        setSearchParams(params);
    };
    // date range plugin

    // const exportLogs = async (e) => {
    //     await api
    //         .get('/log/export')
    //         .then((response) => {
    //             //  download zip file
    //             const url = window.URL.createObjectURL(new Blob([response.data]));
    //             const link = document.createElement('a');
    //             link.href = url;
    //             link.setAttribute('download', 'Transaction_Log.csv'); //or any other extension
    //             document.body.appendChild(link);
    //             link.click();
    //         })
    //         .catch((err) => {
    //             toast.error(err.response.data.message);
    //         });
    // };

    return (
        <PageContainer title="Transaction Logs of Users" desc="A detailed view of all transactions of user's account">
            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} gap={2} mb={2}>
                <Field
                    placeholder="Search logs using description, username, email address"
                    value={search}
                    onChange={(e) => {
                        setSearch(e.target.value);
                    }}
                />
                <Button variant="contained" color="primary" onClick={() => searchlogs()}>
                    <Search />
                </Button>
            </Box>
            <CustomTable
                start={<FilterTabs filter={filter} setFilter={setFilter} />}
                end={<DateFilter dateRange={dateRange} setDateRange={setDateRange} apply={readTransactions} />}
                fields={['# ', 'USER', 'DATE AND TIME', 'TYPE', 'DESCRIPTION', 'AMOUNT', 'BONUS', 'BALANCE']}
                loading={laoding}
                pagination
                count={totalPages}
                page={page}
                setPage={setPage}>
                {transactions.map((transaction, i) => (
                    <TableRow>
                        <TableCell>{i + 1}</TableCell>
                        <TableCell
                            sx={{
                                color: 'primary.main',
                            }}>
                            {transaction.user.username}
                        </TableCell>
                        <TableCell>{formatDate(transaction.createdAt)}</TableCell>
                        <TableCell
                            sx={{
                                color: 'warning.main',
                            }}>
                            {transaction.type}
                        </TableCell>
                        <TableCell>{transaction.action}</TableCell>
                        <TableCell
                            sx={{
                                color:
                                    transaction.amount > 0
                                        ? 'success.main'
                                        : transaction.amount < 0
                                        ? 'error.main'
                                        : '',
                            }}>
                            {transaction.amount > 0 ? '+$' : '$'} {transaction.amount.toFixed(2)}
                        </TableCell>
                        <TableCell
                            sx={{
                                color: transaction.bonus ? 'primary.main' : 'text.secondary',
                            }}>
                            {transaction.bonus ? '$' + transaction.bonus.toFixed(2) : 'N/A'}
                        </TableCell>
                        <TableCell>{'$' + transaction.balance.toFixed(2)}</TableCell>
                    </TableRow>
                ))}
            </CustomTable>
        </PageContainer>
    );
};

export default Transactions;
